import React from 'react'

const BreakIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='14'
    height='14'
    viewBox='0 0 14 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M2.33337 12.25V11.0833H11.6667V12.25H2.33337ZM4.66671 9.91667C4.02504 9.91667 3.47574 9.68819 3.01879 9.23125C2.56185 8.77431 2.33337 8.225 2.33337 7.58333V1.75H11.6667C11.9875 1.75 12.2622 1.86424 12.4907 2.09271C12.7191 2.32118 12.8334 2.59583 12.8334 2.91667V4.66667C12.8334 4.9875 12.7191 5.26215 12.4907 5.49062C12.2622 5.7191 11.9875 5.83333 11.6667 5.83333H10.5V7.58333C10.5 8.225 10.2716 8.77431 9.81462 9.23125C9.35768 9.68819 8.80837 9.91667 8.16671 9.91667H4.66671ZM10.5 4.66667H11.6667V2.91667H10.5V4.66667Z'
      fill='currentColor'
    />
  </svg>
)

export default BreakIcon
